if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    extractProductRecommendations(html) {
      const match = html.match(/<product-recommendations[^>]*>([\s\S]*?)<\/product-recommendations>/);
      return match ? match[1].trim() : '';
    }

    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const recommendationsHTML = this.extractProductRecommendations(text);

            if (recommendationsHTML.length) {
              this.innerHTML = lazyTemplateController.cleanHTMLWithTemplate(recommendationsHTML);
              scriptController.saveExternalResourcesFromContainer(this);
            }
            if (!this.querySelector('slider-component') && this.classList.contains('complementary-products')) {
              this.remove();
            }
            if (html.querySelector('.slider__slide')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}